// extracted by css-extract-rspack-plugin
export default {"wrap":"Card_wrap__Qlu3b","no-padding":"Card_no-padding__ocLGH"};